export enum Language {
    English,
    Spanish,
    Other = 1000
}

export const Languages: { id: string, name: string, englishName: string, number: number }[] = [
    { id: 'English', name: 'English', englishName: 'English', number: 1 },
    { id: 'Spanish', name: 'Español', englishName: 'Spanish', number: 2 },
    { id: 'Unknown', name: 'Unknown', englishName: 'Unknown', number: 99 },
    { id: 'Other', name: 'Other', englishName: 'Other', number: 1000 },
];
